module.exports = __webpack_public_path__ + "static/media/11_DSC5611.bc6ecfa3.jpg";